import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-expanded-section',
    templateUrl: './expanded-section.shared.component.html',
    styleUrls: ['./expanded-section.shared.component.scss']
})
export class ExpandedSectionComponent implements OnInit {
    @Input() public feel: OLO.Components.EXPANDED_SECTION_FEEL = 'primary';
    constructor() { }

    ngOnInit(): void { }
}
